<template>
    <div>
        <Loader v-if="loading" :min-height="'100%'"></Loader>
        <div v-for="(item, key) in topQuizes.list" :key="key" class="flex mb-2">
            <div class="flex-10 font-weight-bold">
                <a @click.prevent="gotoQuiz(item)" href="">
                    {{ item.title }}
                </a>
            </div>
            <div class="detail-number flex-4">{{ item.visited }}</div>
        </div>

        <div v-if="!topQuizes.list.length">
            <div class="text-center">No top page stats found</div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
    name: 'top-pages',

    components: {
        Loader
    },

    props: {
        getDay: {
            type: Number,
            default: 0
        },

        topQuizes: {
            type: Object,
            default: () => {}
        },

        loading: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        gotoQuiz(quiz) {
            /*--------------------------------------------
            /* Approval Quiz - quizzes.approval.questions
            /* User Quiz quizzes.user.questions
            /* Admin Quiz quizzes.quiz.questions
            ---------------------------------------------*/

            var rounterData = null

            if (quiz.quizCreateType == 'admin') {
                rounterData = this.$router.resolve({
                    name: 'quizzes.quiz.questions',
                    params: {
                        id: quiz.id
                    }
                })
            }

            if (quiz.quizCreateType == 'approval') {
                rounterData = this.$router.resolve({
                    name: 'quizzes.approval.questions',
                    params: {
                        id: quiz.id
                    }
                })
            }

            if (quiz.quizCreateType == 'user') {
                rounterData = this.$router.resolve({
                    name: 'quizzes.user.questions',
                    params: {
                        id: quiz.id
                    }
                })
            }

            window.open(rounterData.href, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
}

.flex-4 {
    flex: 0.4;
}

.flex-10 {
    flex: 1;
}

.detail-number {
    text-align: end;
}

@media screen and (max-width: 960px) {
    .graph-footer > div {
        margin-right: 0.5rem;
    }

    .detail-number {
        flex: 0.2;
    }
}
</style>
